import cookie from "cookie";
import { UtmParams } from "@ecologi/shared";

const COOKIE_NAME = "_ecologi_attribution";
const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_CONSENT_DOMAIN;

export function getAttributionCookie(): UtmParams | null {
  if (typeof document === "undefined") return null;

  const cookies = cookie.parse(document.cookie);
  const value = cookies[COOKIE_NAME];

  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function clearAttributionCookie(): void {
  if (typeof document === "undefined") return;

  document.cookie = cookie.serialize(COOKIE_NAME, "", {
    maxAge: 0,
    domain: COOKIE_DOMAIN,
    path: "/",
  });
}
